'use strict';

/**
 * @ngdoc service
 * @name mx.SolutionBuilderAgent.ActionCoRuService
 * @module mx.SolutionBuilderAgent
 *
 * @description
 * A service provides methods for provide action commit for execute related CoRus.
 * Since IIS limits http header size we have 2 approach for handle actions.
 * When action contains les then `COMMIT_BY_HEADER_COUNT_LIMIT` objects we handle action commit using mx-action header.
 * otherwise we call separate web method.
 */
ActionCoRuService.$inject = ['$q', 'mx.SolutionBuilderAgent.Http'];

export default function ActionCoRuService($q, http) {
	const COMMIT_BY_HEADER_COUNT_LIMIT = 100;

	return {
		getActionContextHeader: getActionContextHeader,
		commit: commit,
	};

	/**
	 * @ngdoc method
	 * @name mx.SolutionBuilderAgent.ActionCoRuService#getActionContextHeader
	 *
	 * @description
	 * Prepares mx-action header when action objects did not exceed the `COMMIT_BY_HEADER_COUNT_LIMIT`.
	 * @param {Guid} actionId - action id.
	 * @param {Guid[]} objectIds - array of object ids.
	 */
	function getActionContextHeader(actionId, objectIds) {
		if (!actionId || !Array.isArray(objectIds) || !objectIds.length || objectIds.length > COMMIT_BY_HEADER_COUNT_LIMIT) {
			return;
		}
		const headerParams = { 'mx-Action': JSON.stringify([actionId].concat(objectIds)) };
		return { headers: headerParams };
	}

	/**
	 * @ngdoc method
	 * @name mx.SolutionBuilderAgent.ActionCoRuService#commit
	 * @param {Guid} actionId - action id.
	 * @param {Guid} cacheId cache id of checked objects.
	 */
	async function commit(actionId, cacheId) {
		return actionId && cacheId && http.post(`api/actions/commit/${actionId}?cacheId=${cacheId}`);
	}
}
